// libraries.
import Button from 'react-bootstrap/Button';
import { useSelector } from 'react-redux';

// selectors.
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';
import {
  getTabsDocumentsReview,
  TabsDocumentsReviewOption,
} from '@domains/documents-review/store/slices/document-review-slice';

// assets.
import { IconPicture } from '@assets/icons';

export const ReviewButtons = () => {
  const country = useSelector(getCountry) || 'CO';
  const activeTab = useSelector(getTabsDocumentsReview);

  const LINKS = {
    MX: {
      media:
        'https://drive.google.com/drive/folders/1BgkFvzrmlrmoYhr4SyUIvUh9ZMCJLRiD',
    },
    CO: {
      media: 'https://drive.google.com/drive/folders/0ALK6cbkhSUUSUk9PVA',
    },
  };

  const handleOpenLink = (url: string) => {
    window.open(url, '_blank');
  };

  if (activeTab !== TabsDocumentsReviewOption.DOCUMENTS) return null;

  return (
    <div className="d-flex px-4 pb-4">
      <Button
        className="d-flex align-items-center gap-2 btn-habi-white"
        onClick={() => handleOpenLink(LINKS[country].media)}
        variant="light"
      >
        <IconPicture />
        <span>Ver fotos y videos</span>
      </Button>
    </div>
  );
};
